import React from "react";
import styles from "./Home.module.css";
import { Image } from "antd";
import coreLogo from "../assets/logo_core-removebg-preview.png";

const HomePage: React.FC = () => {
  return (
    <div className={`home-page ${styles.homeContainer}`}>
      <div className={styles.textContainer}>
        <h1>Benvenuti su</h1>
        <Image
          src={coreLogo}
          alt="logo ICEP Platform"
          preview={false}
          style={{
            maxWidth: "400px",
            width: "100%",
            height: "auto",
            display: "block",
            margin: "0 auto",
          }}
        />
        <p>
          Piattaforma per la diagnostica e cura delle malattie rare
          cardiovascolari
        </p>
      </div>
    </div>
  );
};

export default HomePage;
